import {useContext, useEffect, useState} from 'react';
import {EnvConfigContext} from '../config';
import {MixpanelContainer} from '../components/MixpanelContainer';
import {fetchChannel} from '../api/rainbow';

export const AuthMixpanel = () => {
  const {environment} = useContext(EnvConfigContext);
  const [channelCode, setChannelCode] = useState<string>();

  useEffect(() => {
    fetchChannel()
      .then((channel) => setChannelCode(channel.code))
      .catch(() => {});
  }, []);

  if (!channelCode) {
    return null;
  }

  return (
    <MixpanelContainer
      channelCode={channelCode}
      isProduction={environment === 'prod'}
    />
  );
};
